import React from 'react'
import './App.css'
import { Link, useHistory, withRouter, Redirect } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { RiCheckboxBlankLine, RiCheckboxFill } from 'react-icons/ri'

import { API_URL } from './config'

// export default withRouter (Redirect);

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      response: '',
      error: '',
      errorDisplay: 'none',
      spinning: 'none',
      updateDisplay: 'block',
      optionOne: 'item-select',
      onRadioOne: false,
      offRadioOne: true,
    }
  }

  componentDidMount() {
    document.title = 'Karamale - Log in or sign up'
    localStorage.removeItem('partner')
  }

  existingAudience = () => {
    const { onRadioOne, offRadioOne } = this.state
    if (offRadioOne == true) {
      this.setState({
        optionOne: 'item-select-active',
        offRadioOne: false,
        onRadioOne: true,
      })
      localStorage.setItem('partner', 'yes')
    } else {
      this.setState({
        optionOne: 'item-select',
        offRadioOne: true,
        onRadioOne: false,
      })
      localStorage.removeItem('partner')
    }
    // alert(localStorage.getItem("partner"));
    // localStorage.setItem("audience", audience);
  }

  handleEmail = (event) => {
    this.setState({
      email: event.target.value,
      errorDisplay: 'none',
    })
  }

  handlePassword = (event) => {
    this.setState({
      password: event.target.value,
      errorDisplay: 'none',
    })
  }

  submitLogin = async (event) => {
    setTimeout(() => {
      this.setState({ errorDisplay: 'none' })
    }, 4000)
    this.setState({ updateDisplay: 'none', spinning: 'block' })
    const email = this.state.email
    const password = this.state.password
    const posterUri = ''
    let partner = ''

    if (localStorage.getItem('partner') !== null) {
      partner = 'yes'
    } else {
      partner = ''
    }

    // alert(partner);

    // get user operating system
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS'
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS'
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows'
    } else if (/Android/.test(userAgent)) {
      os = 'Android'
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux'
    }
    const OS = os
    if (email.trim() === '') {
      this.setState({
        error: 'Email or phone required',
        errorDisplay: 'block',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else if (password.trim() === '') {
      this.setState({
        error: 'Password is required',
        errorDisplay: 'block',
        updateDisplay: 'block',
        spinning: 'none',
      })
    } else {
      const apiurl = `${API_URL}/apps/kscanner/loginWeb.php`
      const formData = new FormData()
      formData.append('os', OS)
      formData.append('posterUri', posterUri)
      formData.append('email', email)
      formData.append('password', password)
      formData.append('partner', this.state.onRadioOne ? 'yes' : 'no')
      // formData.append("query", "LOGIN-WEB");

      Axios({
        method: 'POST',
        url: apiurl,
        data: formData,
        withCredentials: true,
      })
        .then((res) => {
          console.log(res.data.status)
          if (res.data.status !== 'success') {
            alert(res.data)
            return
          }
          const response = res.data?.data
          const account_id = response?.account_id
          const account_name = response?.account_name.trim()
          const account_type = response?.account_type.trim()

          if (account_type === 'customer') {
            localStorage.setItem('customerid', account_id)
            localStorage.setItem('customername', account_name)
            localStorage.setItem('accounttype', account_type)
            this.props.history.push({
              pathname: '/customerdashboard',
              state: {
                accounttype: response?.account_type,
                accountid: response?.account_id,
                customername: response?.account_name,
              },
            })
          } else if (account_type === 'business') {
            localStorage.setItem('businessid', account_id)
            localStorage.setItem('businessname', account_name)
            localStorage.setItem('accounttype', account_type)
            this.props.history.push({
              pathname: '/dashboard',
              state: {
                accounttype: account_type,
                accountid: account_id,
                businessname: account_name,
              },
            })
          } else if (account_type === 'partner') {
            localStorage.setItem('partnerid', account_id)
            localStorage.setItem('partnername', account_name)
            localStorage.setItem('accounttype', account_type)
            this.props.history.push({
              pathname: '/in',
              state: {
                accounttype: account_type,
                accountid: account_id,
                businessname: account_name,
              },
            })
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.setState({
              error: error.response.data.errorText,
              errorDisplay: 'block',
              updateDisplay: 'block',
              spinning: 'none',
            })
            console.log('Error:', error.response.data.errorText)
          } else {
            this.setState({
              error: 'Unexpected error:' + error.message,
              errorDisplay: 'block',
              updateDisplay: 'block',
              spinning: 'none',
            })
            console.log('Unexpected error:', error.message)
          }
        })
    }
  }

  render() {
    if (localStorage.getItem('customername') !== null) {
      return <Redirect to="/customerdashboard" />
      //   return exit(1);
    } else {
    }

    const { onRadioOne, offRadioOne } = this.state

    return (
      <div className="view">
        {/* <Header /> */}
        <div className="container">
          <div className="row justify-content-center align-content-center login-screen-container">
            <div className="col-lg-6 col-10 align-self-center">
              <div className="log-title login-logo">
                <Link to="/">
                  <img src={`${API_URL}/karamale.png`} />
                </Link>
              </div>
              <h2 className="login-h2 d-none d-lg-block d-md-block">
                Built for organisers. Trusted by attendees. Powered by Karamale.
                <br />
                <label className="mb-0 color-blue font-size-15 mt-4">
                  <Link to="/aboutkaramale" className="color-blue font-normal text-underline-none">
                    Learn more...
                  </Link>
                </label>
              </h2>
            </div>

            <div className="col-lg-5 pl-0 pr-0">
              <div className="BoxDashboardContainer">
                <input
                  type="text"
                  placeholder="Email address or phone number"
                  value={this.state.email}
                  onChange={this.handleEmail}
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.handlePassword}
                />
                <div className={'w-100 mb-3 cursor-pointer'} onClick={this.existingAudience}>
                  {onRadioOne && <RiCheckboxFill size={18} color={'#000'} />}
                  {offRadioOne && <RiCheckboxBlankLine size={18} color={'#000'} />}
                  &nbsp;Login as an affiliate partner
                </div>

                <div className="col-12 response textMedium pl-0">{this.state.response}</div>
                <button onClick={() => this.submitLogin()} className="w-100 mb-3">
                  <span
                    style={{
                      display: this.state.updateDisplay,
                    }}
                  >
                    Log In
                  </span>
                  <span
                    style={{
                      display: this.state.spinning,
                    }}
                  >
                    <ClipLoader
                      color={'#fff'}
                      loading={true}
                      // css={override}
                      size={20}
                    />
                  </span>
                </button>
                <div className="col-12 text-center">
                  <Link to={{ pathname: '/password', state: { password: true } }}>
                    <label className="text-center">Forgot password</label>
                  </Link>
                  <label className="mb-0 pipe-holder">
                    {' '}
                    &nbsp;&nbsp;
                    <label className="color-grey-light pipe">|</label>
                    &nbsp;&nbsp;
                  </label>
                  <label className="break-to-next-line mb-0">
                    <br />
                  </label>
                  <Link to={{ pathname: '/aboutsalesparnter' }}>
                    <label className="text-center">About Affiliation</label>
                  </Link>
                </div>

                <div className="horizontal-line "></div>

                <Link to="/registration" className="text-decoration-none">
                  <div className="cancel-btn text-center">Create new Account</div>
                </Link>
              </div>

              <div className="text-footer text-center mb-4">
                Create <span>unlimited</span> events, load <span>tickets</span> and sell
              </div>
            </div>
          </div>
        </div>

        <div
          className="error-login"
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    )
  }
}

export default Login
